// import React, { useState } from "react";
// import { FaCog, FaSignOutAlt, FaBars } from "react-icons/fa";
// import { Link } from "react-router-dom";
// import { useLocation } from "react-router-dom";
// import cehrLogo from "../../assets/CeHR.png";
// import empl from "../../assets/employee.png";
// import en from "../../assets/en.png";
// import re from "../../assets/re.png";
// import req from "../../assets/req.png";
// import chat from "../../assets/cat.png";
// import productivity from "../../assets/productive.png";
// import resources from "../../assets/Vector.png";
// import PE from "../../assets/PE.png";
// import SE from "../../assets/setttings.png";
// import DB from "../../assets/DAS.png";
// import QM from "../../assets/qm.png";
// import CR from "../../assets/cr.png";

// const Sidebar = ({ children }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const location = useLocation();

//   const links = [
//     { to: "/", label: "Dashboard", icon: DB },
//     { to: "/employee", label: "Employees", icon: empl },
//     { to: "/engagement", label: "Engagement", icon: en },
//     { to: "/recruitement", label: "Recruitement", icon: re },
//     { to: "/requests", label: "Requests", icon: req },
//     { to: "/chat", label: "Chats", icon: chat },
//     { to: "/productivity", label: "Productivity", icon: productivity },
//     { to: "/resources", label: "Resources", icon: resources },
//     { to: "/query-management", label: "Query Management", icon: QM },
//     { to: "conflict-resolution", label: "Conflict Resolution", icon: CR },

//     {
//       to: "/performance-evaluation",
//       label: "Performance Evaluation",
//       icon: PE,
//     },
//     { to: "/company-settings", label: "Company Settings", icon: SE },
//     { to: "/profile", label: "Profile", icon: req },
//   ];

//   return (
//     <div className="font-Outfit min-h-screen overflow-y-scroll">
//       <button
//         className="absolute top-6 left-2 md:hidden text-md text-[#202020]"
//         onClick={() => setIsOpen(!isOpen)}
//       >
//         <FaBars />
//       </button>
//       <div className="nav">
//         <div
//           className={`fixed w-52 z-10 h-full bg-[#FFFFFF] shadow-lg flex flex-col justify-between transition-transform duration-300 ${
//             isOpen ? "translate-x-0" : "-translate-x-full w-0"
//           } md:translate-x-0 p-5`}
//         >
//           <button
//             className="md:hidden relative font-DM_SANS right-20 block font-bold text-2xl text-[#202020]"
//             onClick={() => setIsOpen(!isOpen)}
//           >
//             X
//           </button>

//           <div>
//             <Link>
//               <div className=" flex gap-4 items-center">
//                 <img
//                   className="w-20 mx-auto"
//                   src={cehrLogo}
//                   alt="Logo"
//                 />
//               </div>
//             </Link>
//           </div>

//           <nav className="font-Outfit mx-auto mt-8 text-xs">
//             {links.map(({ to, label, icon }) => (
//               <Link
//                 key={to}
//                 to={to}
//                 className={`block relative text-sm sm:text-sm py-2 rounded mb-4 ${
//                   location.pathname === to
//                     ? "text-[#3C60FF] font-semibold active-link"
//                     : "text-black"
//                 }`}
//               >
//                 <span className="absolute left-0 top-0 bottom-0 w-1 bg-[#3C60FF] rounded-tr-lg rounded-br-lg transform scale-0 transition-transform duration-300 origin-left">
//                   {location.pathname === to && (
//                     <span className="block h-full w-1  rounded-tr-lg rounded-br-lg"></span>
//                   )}
//                 </span>
//                 <span className="inline-flex items-center">
//                   <div className="w-4 h-4">
//                     <img
//                       className="w-full h-full"
//                       src={icon}
//                       alt=""
//                     />
//                   </div>
//                   <span className="ml-3">{label}</span>
//                 </span>
//               </Link>
//             ))}
//           </nav>

//           <div className="mt-auto hover:bg-white grid rounded-full gap-6">
//             <Link
//               to="/login"
//               className="flex hover:bg-white rounded-full items-center text-red-500"
//             >
//               <FaSignOutAlt className="mr-2" /> Logout
//             </Link>
//           </div>
//         </div>
//         <div className="md:ml-52 px-6 bg-[#FAFAFA]">{children}</div>
//       </div>
//       {/* Sidebar */}
//     </div>
//   );
// };

// export default Sidebar;

import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { FaBars, FaSignOutAlt, FaTimes } from "react-icons/fa";
import {
  FiActivity,
  FiAlertOctagon,
  FiBarChart2,
  FiCalendar,
  FiCreditCard,
  FiEdit3,
  FiGrid,
  FiHelpCircle,
  FiInbox,
  FiMessageCircle,
  FiDollarSign,
  FiSettings,
  FiUser,
  FiUsers,
  FiZap,
  FiBriefcase,
  FiFolder,
  FiBookOpen,
  FiChevronDown,
  FiChevronRight,
} from "react-icons/fi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import rawAxios from "axios";
import apiClient from "../../api/httpClient";
import { logout } from "../../data/Reducers/UserReducer";
import {
  clearStoredSession,
  getApiBaseUrl,
  resolveDashboardPath,
} from "../../data/authStorage";
import { GlobalState } from "../../data/Context";
import { DeleteItem } from "../../components/modal";
import { getNotificationActionLabel, getNotificationActionUrl } from "../../utils/notificationNavigation";
import useCurrentEmployee from "../../hooks/useCurrentEmployee";
import {
  ENGAGEMENT_SEEN_EVENT,
  hasUnreadEngagementPosts,
} from "../../utils/engagementUnread";

import { buildAssetUrl } from "../../data/authStorage";
import { listMyNotifications, markMyNotificationAsRead } from "../../api/notifications";
import { getOrganizationFeatureAccess } from "../../api/organizationProfile";
import { getSavingsIssueCount, getSavingsPendingCount } from "../../api/payroll";
import cehrLogo from "../../assets/cehr-logo.png";
import { MODULE_BY_PATH } from "../../data/modules";
const baseLinks = [
  { to: "/engagement", label: "Engagement", icon: FiZap },
  { to: "/recruitement", label: "Recruitment", icon: FiUsers },
  { to: "/requests", label: "Requests", icon: FiInbox },
  { type: "work-group" },
  { type: "finance-group" },
  { type: "employee-relations-group" },
  { to: "/resources", label: "Documents", icon: FiFolder },
  { to: "/support", label: "Support Center", icon: FiHelpCircle },
  { to: "/learning-management", label: "Learning Management", icon: FiBookOpen },
  { type: "group", groupKey: "reporting", label: "Reports & Intelligence", icon: FiBarChart2,
    children: [{ to: "/reporting", label: "Reports & Analytics", icon: FiBarChart2 },
      { to: "/reporting/intelligence", label: "Intelligence", icon: FiZap },
      { to: "/reporting/recommendations", label: "Recommendations", icon: FiZap }] },
  { to: "/company-settings", label: "Company Settings", icon: FiSettings },
  { to: "/profile", label: "Profile", icon: FiUser },
];

const PLAN_FEATURE_BY_PATH = {
  "/payroll": "payroll",
  "/e-wallet": "wallet",
  "/talent-management": "talent",
  "/learning-management": "learning-management-system",
  "/reporting/intelligence": "intelligence",
  "/reporting/recommendations": "intelligence",
};

const getRoleText = (employee) =>
  [
    employee?.positionName,
    employee?.position?.name,
    employee?.roleName,
    employee?.role?.name,
    employee?.assignmentLabel,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

const Sidebar = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDesktopCollapsed, setIsDesktopCollapsed] = useState(false);
  const [isDesktopHoverExpanded, setIsDesktopHoverExpanded] = useState(false);
  const desktopSidebarExpanded = !isDesktopCollapsed || isDesktopHoverExpanded;
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [hasUnreadEngagement, setHasUnreadEngagement] = useState(false);
  const [pendingSavingsRequests, setPendingSavingsRequests] = useState(0);
  const [openSavingsIssues, setOpenSavingsIssues] = useState(0);
  const [notificationPopup, setNotificationPopup] = useState(null);
  const [enabledFeatures, setEnabledFeatures] = useState(null);
  const [peopleOpen, setPeopleOpen] = useState(() =>
    window.location.pathname.startsWith("/employee") || window.location.pathname.startsWith("/contract-staff") || window.location.pathname.startsWith("/job-descriptions"),
  );
  const [dashboardOpen, setDashboardOpen] = useState(() =>
    window.location.pathname.startsWith("/employee-dashboard") || window.location.pathname === "/dashboard",
  );
  const [financeOpen, setFinanceOpen] = useState(() =>
    window.location.pathname.startsWith("/e-wallet") || window.location.pathname.startsWith("/payroll"),
  );
  const [workOpen, setWorkOpen] = useState(() =>
    ["/productivity", "/attendance", "/performance-evaluation"].some((route) =>
      window.location.pathname === route || window.location.pathname.startsWith(`${route}/`),
    ),
  );
  const [employeeRelationsOpen, setEmployeeRelationsOpen] = useState(() =>
    window.location.pathname.startsWith("/query-management") ||
    window.location.pathname.startsWith("/conflict-resolution") ||
    window.location.pathname.startsWith("/surveys"),
  );
  const [reportingOpen, setReportingOpen] = useState(() => window.location.pathname.startsWith("/reporting"));
  const { organization } = useContext(GlobalState);
  const {
    companyAccount,
    currentEmployee,
    loading: employeeLoading,
  } = useCurrentEmployee();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    let active = true;
    setEnabledFeatures(null);
    getOrganizationFeatureAccess()
      .then((access) => {
        if (active) setEnabledFeatures(access?.enabledFeatures || {});
      })
      .catch(() => {
        // Hide plan-gated navigation until access can be confirmed.
        if (active) setEnabledFeatures({});
      });
    return () => { active = false; };
  }, [organization?.id, companyAccount, currentEmployee?.id]);
  const dashboardPath = resolveDashboardPath(organization);
  const organizationLogo = buildAssetUrl(organization?.logoUrl || organization?.logo || organization?.image);
  const isHod = useMemo(() => {
    const roleText = getRoleText(currentEmployee);
    return Boolean(
      !companyAccount &&
        currentEmployee &&
        (currentEmployee.isHeadOfDepartment ||
          roleText.includes("hod") ||
          roleText.includes("head of department")),
    );
  }, [companyAccount, currentEmployee]);

  useEffect(() => {
    if (companyAccount || !currentEmployee?.id) return undefined;
    let active = true;
    const poll = async () => {
      try {
        const response = await listMyNotifications({ page: 1, limit: 10 });
        const latest = (response?.notifications || []).find(
          (item) => !item.isRead && ["chat_mention", "chat_membership", "project"].includes(item.type),
        );
        if (!latest || !active) return;
        const storageKey = `cehr_notification_popup_${currentEmployee.id}`;
        if (window.sessionStorage.getItem(storageKey) !== latest.id) {
          window.sessionStorage.setItem(storageKey, latest.id);
          setNotificationPopup(latest);
        }
      } catch {
        // Notification polling must never interrupt normal navigation.
      }
    };
    poll();
    const timer = window.setInterval(poll, 15000);
    return () => { active = false; window.clearInterval(timer); };
  }, [companyAccount, currentEmployee?.id]);
  const links = useMemo(
    () => {
      const permissions = currentEmployee?.modulePermissions || [];
      if (currentEmployee?.isContractor) {
        const allowed = (moduleId) => permissions.includes(moduleId);
        const contractorLinks = [
          allowed('dashboard') ? { to: '/employee-dashboard', label: 'Dashboard', icon: FiGrid } : null,
          allowed('employees') ? { to: '/employee', label: 'Employees', icon: FiUsers } : null,
          allowed('productivity') ? { to: '/productivity', label: 'Projects & Tasks', icon: FiActivity } : null,
          allowed('chats') ? { to: '/chat', label: 'Chats', icon: FiMessageCircle } : null,
          allowed('attendance') ? { to: '/attendance', label: 'Attendance', icon: FiCalendar } : null,
          allowed('engagement') ? { to: '/engagement', label: 'Engagement', icon: FiZap } : null,
          allowed('requests') ? { to: '/requests', label: 'Requests', icon: FiInbox } : null,
          allowed('documents') ? { to: '/resources', label: 'Documents', icon: FiFolder } : null,
          allowed('payroll') ? { to: '/payroll', label: 'Payroll', icon: FiDollarSign } : null,
          allowed('e-wallet') ? { to: '/e-wallet', label: 'E-Wallet', icon: FiCreditCard } : null,
          allowed('surveys') ? { to: '/surveys', label: 'Surveys', icon: FiEdit3 } : null,
          allowed('query-management') ? { to: '/query-management', label: 'Queries', icon: FiHelpCircle } : null,
          allowed('conflict-resolution') ? { to: '/conflict-resolution', label: 'Conflict Resolution', icon: FiAlertOctagon } : null,
          allowed('performance-evaluation') ? { to: '/performance-evaluation', label: 'Performance Evaluation', icon: FiBarChart2 } : null,
          allowed('reporting') ? baseLinks.find((link) => link.groupKey === 'reporting') : null,
          allowed('company-settings') ? { to: '/company-settings', label: 'Company Settings', icon: FiSettings } : null,
          allowed('profile') ? { to: '/profile', label: 'Profile', icon: FiUser } : null,
        ].filter(Boolean);
        return contractorLinks;
      }
      const peopleChildren = [
        (companyAccount || isHod || permissions.includes("employees"))
          ? { to: "/employee", label: "Employees", icon: FiUsers }
          : null,
        (companyAccount || permissions.includes("recruitement") || permissions.includes("recruitment") || permissions.includes("job-descriptions"))
          ? { to: "/talent-management", label: "Talent Management", icon: FiBriefcase }
          : null,
        (companyAccount || permissions.includes("job-descriptions"))
          ? { to: "/job-descriptions", label: "Job Descriptions", icon: FiBriefcase }
          : null,
        (companyAccount || permissions.includes("job-descriptions") || permissions.includes("guarantor-forms") || permissions.includes("guarantor-form"))
          ? { to: "/guarantor-forms", label: "Guarantor Forms", icon: FiEdit3 }
          : null,
      ].filter(Boolean);
      const employeeRelationsChildren = [
        (companyAccount || permissions.includes("query-management"))
          ? { to: "/query-management", label: "Query Management", icon: FiHelpCircle }
          : null,
        (companyAccount || permissions.includes("conflict-resolution"))
          ? { to: "/conflict-resolution", label: "Conflict Resolution", icon: FiAlertOctagon }
          : null,
        (companyAccount || permissions.includes("surveys"))
          ? { to: "/surveys", label: "Employee Surveys", icon: FiEdit3 }
          : null,
      ].filter(Boolean);
      const hasAdminDashboardAccess = !companyAccount && permissions.includes("dashboard");
      const navigationItems = [
        ...(hasAdminDashboardAccess
          ? [{
              type: "group",
              groupKey: "dashboard",
              label: "Dashboard",
              icon: FiGrid,
              children: [
                { to: "/employee-dashboard", label: "My Dashboard", icon: FiGrid },
                { to: "/dashboard", label: "Admin Dashboard", icon: FiGrid },
              ],
            }]
          : [{ to: dashboardPath, label: "Dashboard", icon: FiGrid }]),
        ...(peopleChildren.length
          ? [{ type: "group", label: "People Management", icon: FiUsers, children: peopleChildren }]
          : []),
        ...baseLinks.filter((link) => {
        if (link.type === "finance-group" || link.type === "employee-relations-group" || link.type === "work-group") return true;
        if (link.groupKey === "reporting") return companyAccount || permissions.includes("reporting");
        const moduleId = MODULE_BY_PATH[link.to];
        const hasPermission = moduleId && permissions.includes(moduleId);
        if (link.to === "/support") return companyAccount;
        if (link.to === "/learning-management") return true;
        if (link.to === "/company-settings") {
          return companyAccount || hasPermission;
        }
        return true;
      }).map((link) => link.type === "work-group" ? {
        type: "group",
        groupKey: "work",
        label: "Work Management",
        icon: FiActivity,
        children: [
          { to: "/productivity", label: "Productivity", icon: FiActivity },
          { to: "/attendance", label: "Attendance", icon: FiCalendar },
          { to: "/calendar", label: companyAccount ? "Calendar" : "My Calendar", icon: FiCalendar },
          { to: "/performance-evaluation", label: "Performance Evaluation", icon: FiBarChart2 },
        ],
      } : link.type === "finance-group" ? {
        type: "group",
        groupKey: "finance",
        label: "Finance & Rewards",
        icon: FiDollarSign,
        children: [
          { to: "/e-wallet", label: "E-Wallet", icon: FiCreditCard },
          { to: "/payroll", label: "Payroll", icon: FiDollarSign },
        ],
      } : link.type === "employee-relations-group" ? {
        type: "group",
        groupKey: "employee-relations",
        label: "Employees Relations",
        icon: FiHelpCircle,
        children: employeeRelationsChildren,
      } : link),
      ];

      const filterPlanFeatures = (items) => items.flatMap((item) => {
        if (item.children) {
          const children = filterPlanFeatures(item.children);
          return children.length ? [{ ...item, children }] : [];
        }
        const featureKey = item.featureKey || PLAN_FEATURE_BY_PATH[item.to];
        if (featureKey && enabledFeatures?.[featureKey] !== true) return [];
        return [item];
      });

      return filterPlanFeatures(navigationItems);
    },
    [companyAccount, currentEmployee, dashboardPath, enabledFeatures, isHod],
  );
  const employeeId = currentEmployee?.id || "";

  const refreshSavingsRequests = useCallback(async () => {
    if (employeeLoading) return;
    try {
      const [response, issues] = await Promise.all([getSavingsPendingCount(), getSavingsIssueCount()]);
      setPendingSavingsRequests(Number(response?.count || 0));
      setOpenSavingsIssues(Number(issues?.count || 0));
    } catch {
      setPendingSavingsRequests(0);
      setOpenSavingsIssues(0);
    }
  }, [employeeLoading]);

  useEffect(() => {
    refreshSavingsRequests();
    const timer = window.setInterval(refreshSavingsRequests, 30000);
    window.addEventListener("focus", refreshSavingsRequests);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("focus", refreshSavingsRequests);
    };
  }, [refreshSavingsRequests]);

  const refreshEngagementUnread = useCallback(async () => {
    if (companyAccount || employeeLoading || !employeeId) {
      setHasUnreadEngagement(false);
      return;
    }

    const apiBaseUrl = getApiBaseUrl();

    if (!apiBaseUrl) {
      setHasUnreadEngagement(false);
      return;
    }

    try {
      const response = await apiClient.get(
        `${apiBaseUrl}/organizations/engagement/posts`,
        {
          params: {
            viewer: "employee",
            employeeId,
            page: 1,
            limit: 8,
          },
        },
      );
      const posts = response?.data?.posts || [];
      setHasUnreadEngagement(hasUnreadEngagementPosts(posts, employeeId));
    } catch {
      setHasUnreadEngagement(false);
    }
  }, [companyAccount, employeeId, employeeLoading]);

  useEffect(() => {
    refreshEngagementUnread();
  }, [refreshEngagementUnread]);

  useEffect(() => {
    if (companyAccount) {
      return undefined;
    }

    const handleRefresh = () => {
      if (document.visibilityState !== "hidden") {
        refreshEngagementUnread();
      }
    };

    window.addEventListener("focus", handleRefresh);
    document.addEventListener("visibilitychange", handleRefresh);
    window.addEventListener(ENGAGEMENT_SEEN_EVENT, handleRefresh);

    return () => {
      window.removeEventListener("focus", handleRefresh);
      document.removeEventListener("visibilitychange", handleRefresh);
      window.removeEventListener(ENGAGEMENT_SEEN_EVENT, handleRefresh);
    };
  }, [companyAccount, refreshEngagementUnread]);

  const handleConfirmLogout = async () => {
    setIsLoggingOut(true);
    const apiBaseUrl = (process.env.REACT_APP_API_BASE_URL || "").replace(
      /\/+$/,
      "",
    );

    try {
      if (apiBaseUrl) {
        // Set a timeout of 5 seconds for logout request
        const logoutPromise = rawAxios.post(
          `${apiBaseUrl}/auth/organization/logout`,
          {},
        );

        await Promise.race([
          logoutPromise,
          new Promise((_, reject) =>
            setTimeout(() => reject(new Error("Logout timeout")), 4000),
          ),
        ]);
      }
    } catch (error) {
      // Local cleanup still proceeds if logout request fails or times out
      console.error("Logout error:", error?.message);
    } finally {
      setOpenLogoutModal(false);
      clearStoredSession();
      dispatch(logout());
      setIsOpen(false);
      setIsLoggingOut(false);
      navigate("/login", { replace: true });
    }
  };

  const closeSidebar = () => setIsOpen(false);
  const isRouteActive = (route) => pathname === route || pathname.startsWith(`${route}/`);
  const closeExpandedMenus = () => {
    setDashboardOpen(false);
    setPeopleOpen(false);
    setWorkOpen(false);
    setFinanceOpen(false);
    setEmployeeRelationsOpen(false);
  };

  return (
    <div className="font-Nunito min-h-screen bg-[#FAFAFA]">
      <div className="h-10 md:h-0">
        <button
          onClick={() => setIsOpen(true)}
          className="md:hidden fixed top-4 left-4 z-30 text-[#202020]"
        >
          <FaBars size={18} />
        </button>
      </div>

      {/* Overlay (click outside to close) */}
      {isOpen && (
        <div
          onClick={closeSidebar}
          className="fixed inset-0 bg-black/30 z-20 md:hidden"
        />
      )}

      <aside
        onMouseEnter={() => { if (isDesktopCollapsed) setIsDesktopHoverExpanded(true); }}
        onMouseLeave={() => setIsDesktopHoverExpanded(false)}
        className={`fixed top-0 left-0 z-30 h-full ${desktopSidebarExpanded ? "w-56" : "w-[4.5rem]"} bg-white shadow-lg transform transition-[width,transform] duration-300 ${isOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0 flex flex-col`}
      >
        <div className={`flex items-center ${desktopSidebarExpanded ? "justify-between p-5" : "flex-col gap-2 p-2"}`}>
          <img
            src={organizationLogo || cehrLogo}
            alt={organizationLogo && organization?.name ? `${organization.name} logo` : "Cephas HR"}
            className={`object-contain transition-all duration-300 ${desktopSidebarExpanded ? "h-16 w-28" : "h-8 w-8"}`}
          />
          <button
            type="button"
            onClick={() => setIsDesktopCollapsed((collapsed) => !collapsed)}
            aria-label={isDesktopCollapsed ? "Expand sidebar" : "Collapse sidebar"}
            aria-expanded={desktopSidebarExpanded}
            className="hidden md:inline-flex rounded-md p-2 text-slate-600 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {isDesktopCollapsed ? <FiChevronRight /> : <FiChevronDown />}
          </button>
          <button
            onClick={closeSidebar}
            className="md:hidden"
          >
            <FaTimes />
          </button>
        </div>

        <nav className={`flex-1 overflow-y-auto ${desktopSidebarExpanded ? "px-5" : "px-3"} text-sm no-scrollbar`}>
          {links.map((item) => {
            if (item.type === "group" && item.children.length === 0) return null;
            const navItem = item.type === "group" && item.children.length === 1
              ? item.children[0]
              : item;
            const { to, label, icon: Icon } = navItem;
            if (navItem.type === "group") {
              const groupActive = navItem.children.some((child) => isRouteActive(child.to));
              const isFinanceGroup = navItem.groupKey === "finance";
              const isWorkGroup = navItem.groupKey === "work";
              const isEmployeeRelationsGroup = navItem.groupKey === "employee-relations";
              const isDashboardGroup = navItem.groupKey === "dashboard";
              const isReportingGroup = navItem.groupKey === "reporting";
              const groupOpen = isReportingGroup ? reportingOpen : isDashboardGroup ? dashboardOpen : isWorkGroup ? workOpen : isFinanceGroup ? financeOpen : isEmployeeRelationsGroup ? employeeRelationsOpen : peopleOpen;
              const setGroupOpen = isReportingGroup ? setReportingOpen : isDashboardGroup ? setDashboardOpen : isWorkGroup ? setWorkOpen : isFinanceGroup ? setFinanceOpen : setPeopleOpen;
              const toggleGroupOpen = isEmployeeRelationsGroup ? setEmployeeRelationsOpen : setGroupOpen;
              return <div key={label} className="mb-2">
                <button
                  type="button"
                  aria-label={desktopSidebarExpanded ? label : `${label} menu`}
                  title={desktopSidebarExpanded ? undefined : label}
                  aria-expanded={groupOpen}
                  onClick={() => {
                    if (isDashboardGroup) {
                      setPeopleOpen(false);
                      setWorkOpen(false);
                      setFinanceOpen(false);
                      setEmployeeRelationsOpen(false);
                    } else if (isWorkGroup) {
                      setDashboardOpen(false);
                      setPeopleOpen(false);
                      setFinanceOpen(false);
                      setEmployeeRelationsOpen(false);
                    } else if (isFinanceGroup) {
                      setDashboardOpen(false);
                      setPeopleOpen(false);
                      setWorkOpen(false);
                      setEmployeeRelationsOpen(false);
                    } else if (isEmployeeRelationsGroup) {
                      setDashboardOpen(false);
                      setPeopleOpen(false);
                      setWorkOpen(false);
                      setFinanceOpen(false);
                    } else {
                      setDashboardOpen(false);
                      setWorkOpen(false);
                      setFinanceOpen(false);
                      setEmployeeRelationsOpen(false);
                    }
                    toggleGroupOpen((current) => !current);
                    navigate(navItem.children[0].to);
                  }}
                  className={`flex w-full items-center ${desktopSidebarExpanded ? "gap-3" : "justify-center"} rounded py-2 text-left ${groupActive ? "font-semibold text-[#3C60FF]" : "text-black"}`}
                >
                  <Icon className="h-4 w-4 shrink-0" aria-hidden="true" />
                  {desktopSidebarExpanded ? <span className="flex-1">{label}</span> : null}
                  {desktopSidebarExpanded ? (groupOpen ? <FiChevronDown className="h-4 w-4" aria-label="Collapse menu" /> : <FiChevronRight className="h-4 w-4" aria-label="Expand menu" />) : null}
                </button>
                {desktopSidebarExpanded && groupOpen ? <div className="ml-4 border-l border-slate-200 pl-4 pt-1">
                  {navItem.children.map((child) => {
                    const ChildIcon = child.icon;
                    const childActive = isReportingGroup ? pathname === child.to : isRouteActive(child.to);
                    return <Link key={child.to} to={child.to} onClick={closeSidebar} className={`mb-1 flex items-center gap-3 rounded px-2 py-2 text-[13px] ${childActive ? "bg-blue-50 font-semibold text-[#3C60FF]" : "text-slate-600 hover:bg-slate-50"}`}>
                      <ChildIcon className="h-3.5 w-3.5 shrink-0" />
                      {child.label}
                    </Link>;
                  })}
                </div> : null}
              </div>;
            }
            const isActive = isRouteActive(to);
            const showUnreadDot =
              !companyAccount && to === "/engagement" && hasUnreadEngagement;
            const payrollCount = pendingSavingsRequests + openSavingsIssues;
            const showPayrollDot = to === "/payroll" && payrollCount > 0;

            return (
              <Link
                key={to}
                to={to}
                onClick={() => {
                  closeExpandedMenus();
                  closeSidebar();
                }}
                title={desktopSidebarExpanded ? undefined : label}
                aria-label={label}
                className={`relative flex items-center ${desktopSidebarExpanded ? "gap-3" : "justify-center"} py-2 mb-3 rounded
                  ${isActive ? "text-[#3C60FF] font-semibold" : "text-black"}`}
              >
                {/* {isActive && (
                  <span className="absolute left-0 top-0 h-full w-1 bg-[#3C60FF] " />
                )} */}

                <Icon className="h-4 w-4 shrink-0" aria-hidden="true" />
                <span className={`relative ${desktopSidebarExpanded ? "inline-flex" : "hidden"} items-center gap-2`}>
                  {label}
                  {showUnreadDot ? (
                    <span
                      className="h-2 w-2 rounded-full bg-[#D92D20]"
                      aria-label="Unread engagement post"
                    />
                  ) : null}
                  {showPayrollDot ? (
                    <span
                      className="min-w-5 rounded-full bg-red-600 px-1.5 py-0.5 text-center text-[10px] font-bold leading-none text-white ring-2 ring-red-100"
                      aria-label={`${payrollCount} pending payroll items`}
                      title={`${payrollCount} pending payroll items`}
                    >{payrollCount}</span>
                  ) : null}
                </span>
              </Link>
            );
          })}
        </nav>

        <div className={`border-t ${desktopSidebarExpanded ? "p-5" : "p-3"}`}>
          <button
            type="button"
            title={desktopSidebarExpanded ? undefined : "Logout"}
            aria-label="Logout"
            className={`flex items-center ${desktopSidebarExpanded ? "gap-2" : "justify-center"} text-red-500`}
            onClick={() => setOpenLogoutModal(true)}
          >
            <FaSignOutAlt />{desktopSidebarExpanded ? " Logout" : null}
          </button>
        </div>
      </aside>

      <DeleteItem
        isOpen={openLogoutModal}
        onClose={() => setOpenLogoutModal(false)}
      >
        <div className="mt-3 w-full text-center">
          <h1 className="text-lg font-bold text-[#000000]">
            Continue to logout?
          </h1>
          <p className="mt-2 text-sm">
            You will need to login again.
          </p>
        </div>
        <div className="my-4 flex w-full items-center justify-center gap-4 py-4">
          <button
            onClick={() => setOpenLogoutModal(false)}
            disabled={isLoggingOut}
            className={`border-[#1233CC] py-1 border-2 text-[#1233CC] font-medium px-4 rounded-[10px] w-[102px] ${
              isLoggingOut ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            No
          </button>
          <button
            className={`text-[16px] font-medium px-4 py-1 bg-[#1233CC] rounded-[10px] w-[102px] text-white flex items-center justify-center gap-2 transition-all ${
              isLoggingOut
                ? "opacity-75 cursor-not-allowed"
                : "hover:bg-[#4001c0]"
            }`}
            onClick={handleConfirmLogout}
            disabled={isLoggingOut}
          >
            {isLoggingOut ? "Logging out..." : "Yes"}
          </button>
        </div>
      </DeleteItem>

      {notificationPopup ? (
        <div className="fixed bottom-5 right-5 z-[100] w-[calc(100%-2.5rem)] max-w-sm rounded-2xl border border-blue-100 bg-white p-4 shadow-2xl">
          <div className="flex items-start gap-3">
            <span className="rounded-xl bg-blue-50 p-2 text-[#1234CD]"><FiMessageCircle /></span>
            <div className="min-w-0 flex-1">
              <p className="font-semibold text-slate-900">{notificationPopup.title}</p>
              <p className="mt-1 line-clamp-3 text-sm text-slate-600">{notificationPopup.message}</p>
              <button
                type="button"
                onClick={async () => {
                  try { await markMyNotificationAsRead(notificationPopup.id); } catch {}
                  setNotificationPopup(null);
                  const actionUrl = getNotificationActionUrl(notificationPopup);
                  navigate(actionUrl || (notificationPopup.type === "project" ? "/productivity?tab=projects" : "/notification"));
                }}
                className="mt-3 text-sm font-semibold text-[#1234CD]"
              >
                {getNotificationActionLabel(notificationPopup)}
              </button>
            </div>
            <button type="button" onClick={() => setNotificationPopup(null)} className="text-slate-400"><FaTimes /></button>
          </div>
        </div>
      ) : null}

      {/* Main content */}
      <main className={`mobile-density px-2 pb-4 pt-2 transition-[margin] duration-300 ${desktopSidebarExpanded ? "md:ml-52" : "md:ml-[4.5rem]"} md:px-4 md:py-4 lg:px-6`}>{children}</main>
    </div>
  );
};

export default Sidebar;
